import theme from "../index";

export const cardIconSx = {
  width: 36,
  height: 36,
  borderRadius: "12px",
  backgroundColor: "#FF3100",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const selectSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: `${theme.radius.medium}px`,
    fontSize: 15, // tamanho do texto no input
    height: "40px",
  },
  "& .MuiInputBase-input": {
    fontSize: 15,
  },
};

export const permissionSwitchTheme = {
  components: {
    Switch: {
      colorPrimary: theme.colors.primary,
      colorPrimaryHover: theme.colors.primary,
      colorTextQuaternary: theme.colors.switchTrackOff,
      colorTextTertiary: theme.colors.switchTrackOffHover,
    },
  },
};

export const permissionLabelStyle = {
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.xs,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: theme.typography.bodyLineHeight,
  color: theme.colors.textPrimary,
};

export const permissionCellStyle = {
  textAlign: "center",
  padding: `${theme.spacing.xxs + 2}px ${theme.spacing.xs}px`,
};

export const permissionThemeVars = {
  "--permission-primary": theme.colors.primary,
  "--permission-primary-soft": theme.colors.primarySoft,
  "--permission-primary-border": theme.colors.primaryBorder,
  "--permission-switch-track-off": theme.colors.switchTrackOff,
  "--permission-switch-track-off-hover": theme.colors.switchTrackOffHover,
  "--permission-switch-track-disabled": theme.colors.switchTrackDisabled,
  "--permission-text-primary": theme.colors.textPrimary,
  "--permission-spacing-xs": `${theme.spacing.xs}px`,
  "--permission-body-size": theme.typography.bodySize,
  "--permission-font-family": theme.typography.fontFamily,
  "--permission-motion": theme.motion.transition,
};

export const clientListThemeVars = {
  "--client-primary": theme.colors.primary,
  "--client-primary-hover": "#001d35",
  "--client-primary-soft": theme.colors.primarySoft,
  "--client-primary-border": theme.colors.primaryBorder,
  "--client-highlight": theme.colors.highlight,
  "--client-highlight-soft": theme.colors.highlightSoft,
  "--client-surface": theme.colors.surface,
  "--client-surface-soft": "rgba(250, 252, 255, 0.92)",
  "--client-text-primary": theme.colors.textPrimary,
  "--client-text-secondary": theme.colors.textSecondary,
  "--client-shadow-soft": "0 14px 28px rgba(1, 36, 66, 0.10)",
  "--client-shadow-table": "0 12px 24px rgba(1, 36, 66, 0.08)",
  "--client-radius-md": `${theme.radius.medium}px`,
  "--client-radius-lg": `${theme.radius.large}px`,
  "--client-font-family": theme.typography.fontFamily,
  "--client-motion": theme.motion.transition,
};

export const newClientThemeVars = {
  "--new-client-primary": theme.colors.primary,
  "--new-client-primary-hover": "#001d35",
  "--new-client-primary-soft": theme.colors.primarySoft,
  "--new-client-primary-border": theme.colors.primaryBorder,
  "--new-client-highlight": theme.colors.highlight,
  "--new-client-highlight-soft": theme.colors.highlightSoft,
  "--new-client-surface": theme.colors.surface,
  "--new-client-surface-soft": "rgba(250, 252, 255, 0.92)",
  "--new-client-text-primary": theme.colors.textPrimary,
  "--new-client-text-secondary": theme.colors.textSecondary,
  "--new-client-shadow-soft": "0 14px 28px rgba(1, 36, 66, 0.10)",
  "--new-client-shadow-section": "0 12px 24px rgba(1, 36, 66, 0.08)",
  "--new-client-radius-md": `${theme.radius.medium}px`,
  "--new-client-radius-lg": `${theme.radius.large}px`,
  "--new-client-font-family": theme.typography.fontFamily,
  "--new-client-motion": theme.motion.transition,
};
